import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.scss';

const UserNote = ({ children, className, ...props }) =>
  <pre className={cx(styles.note, className)} {...props}>{children}</pre>;

UserNote.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default UserNote;



// WEBPACK FOOTER //
// ./client/app/shared/components/UserNote/index.jsx